import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=7c110983&scoped=true&"
import script from "./CardContainer.vue?vue&type=script&lang=js&"
export * from "./CardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c110983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c110983')) {
      api.createRecord('7c110983', component.options)
    } else {
      api.reload('7c110983', component.options)
    }
    module.hot.accept("./CardContainer.vue?vue&type=template&id=7c110983&scoped=true&", function () {
      api.rerender('7c110983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/card/CardContainer.vue"
export default component.exports